export const TAG_STRATEGY_SLUG = 'tag';
export const LIST_STRATEGY_SLUG = 'stakeholder_mgmt_list';
export const MAX_CUSTOM_FIELDS_PAGE_SIZE = 500;
